import { Component, OnInit, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { InstallationObservationPluginService } from './observationsandrecommandations-plugin.service';
import { ObservationMenuComponent } from '../../../menus/index';
import { EditInstallationObservationComponent } from './edit-observation.component';
import { AddInstallationObservationComponent } from './add-observation.component';

import * as _ from 'lodash';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DataService } from '../../../shared/services';

@Component({
    selector: 'observationsandrecommendations-edit',
    templateUrl: './observationsandrecommendations-edit.component.html',
    standalone: false
})
export class InstallationObservationPluginPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  public plugin: any;
  public observationsAndRecommendations: any;
  public newObservationAndRecommendation: any;
  public responsibles: any;
  public priorities: any;
  public machines: any;
  public currentIndex: number;

  @ViewChild('editObservation', { static: true })
  editObservationModal: EditInstallationObservationComponent;
  @ViewChild('addObservation', { static: true })
  addObservationModal: AddInstallationObservationComponent;

  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationObservationPluginService,
    private dataService: DataService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  saveObservation(obs: any) {
    this.observationsAndRecommendations[this.currentIndex] = obs;
  }

  save() {
    this.processing = true;
    let messageInfo = {};
    if (!this.plugin.inspection.isTemplate()) {
      messageInfo = {
        pointName: this.plugin.point.name,
        folderName: this.plugin.point.folder ? this.plugin.point.folder.name : '',
        sectionName: this.plugin.point.section.name,
        templateName: this.plugin.inspection.tplName
      };
    }
    this.pluginService
      .updateObservationsAndRecommendations(
        this.inspectionId,
        this.pointId,
        this.pluginId,
        this.observationsAndRecommendations,
        messageInfo
      )
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  openEditObservation(i: number) {
    const observation = _.clone(this.observationsAndRecommendations[i]);
    this.currentIndex = i;
    this.editObservationModal.open(observation);
  }

  initData() {
    this.service
      .getPlugin(this.inspectionId, this.pluginId)
      .pipe(
        switchMap((data) => {
          this.plugin = data;
          this.observationsAndRecommendations =
            this.plugin.config.ObservationsAndRecommendations != null
              ? this.plugin.config.ObservationsAndRecommendations.map((x: any) => Object.assign({}, x))
              : [];
          this.cdRef.detectChanges();
          return this.dataService.getParrentInspectionLevelPlugin(this.inspectionId, 'installationequipmentinfo').pipe(
            map((equipmentInfo) => {
              let machines = equipmentInfo?.config?.Machines != null ? equipmentInfo.config.Machines : null;
              if (machines) {
                if (!(machines instanceof Array)) {
                  machines = [this.machines];
                }
                this.machines = machines;
              }
            })
          );
        })
      )
      .subscribe();

    this.responsibles = this.pluginService.getResponsibles();
    this.priorities = this.pluginService.getPriorities();
    this.initNewObservationAndRecommendation();
  }

  saveAddObservation() {
    if (this.observationsAndRecommendations == null) this.observationsAndRecommendations = [];
    this.observationsAndRecommendations.push({
      Selected: !this.plugin.inspection.isTemplate(),
      Observation: this.newObservationAndRecommendation.Observation,
      Recommendation: this.newObservationAndRecommendation.Recommendation,
      ToInformAdmin: this.newObservationAndRecommendation.ToInformAdmin,
      CanAddToTemplate: this.newObservationAndRecommendation.CanAddToTemplate,
      Impact: {},
      Responsible: -1,
      Priority: 0
    });
    this.initNewObservationAndRecommendation();
    if (!this.plugin.inspection.isTemplate()) {
      this.openEditObservation(this.observationsAndRecommendations.length - 1);
    }
  }

  public initNewObservationAndRecommendation() {
    this.newObservationAndRecommendation = {
      Observation: '',
      Recommendation: '',
      CanAddToTemplate: !this.plugin.inspection.isTemplate()
    };
  }

  remove(index: number) {
    this.observationsAndRecommendations.splice(index, 1);
  }

  removeObservation() {
    this.remove(this.currentIndex);
  }

  public openMenu(): void {
    this.menuModal.modalFooter = false;
    this.menuModal.modalHeader = false;
    this.menuModal.modalMessage = false;
    this.menuModal.open(ObservationMenuComponent);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 2:
        this.openAddObservation();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  openAddObservation() {
    this.initNewObservationAndRecommendation();
    this.addObservationModal.open(this.newObservationAndRecommendation);
  }

  deletePlugin() {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
